import { render } from "./OrderLegacy.vue?vue&type=template&id=2e92d6d0&scoped=true"
import script from "./OrderLegacy.vue?vue&type=script&lang=js"
export * from "./OrderLegacy.vue?vue&type=script&lang=js"

import "./OrderLegacy.vue?vue&type=style&index=0&id=2e92d6d0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e92d6d0"]])

export default __exports__